module.exports = __webpack_public_path__ + "img/cappuchino.13b9d98f.png";